import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template169: Downtown 1 - Union Square, Cable Car, Lombard. Todo desde backend (page).
// page.texts[0]=header, [1]=intro, [2]=subtitle hero | page.images (portada, tranvia) | page.canvasImages (logo, sticker, sticker-2) | page.sections | page.llegar | page.tipBox
const Template169 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const isSmallScreen = useWindowSize().width <= 600;
	const contentColor = textColor || "#444";

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const introContent = page?.texts?.[1]?.content;
	const subtitle = page?.texts?.[2]?.content;
	const logoImage = getCanvasImageUrl("logo");
	const portadaImage = getImageSrc("portada");
	const portadaSticker = getCanvasImageUrl("sticker");
	const sticker2 = getCanvasImageUrl("sticker-2");
	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];
	const llegar = page?.llegar ?? page?.data?.llegar ?? page?.data?.data?.llegar;
	const tipBox = page?.tipBox ?? page?.data?.tipBox ?? page?.data?.data?.tipBox;

	const actualHeaderColor = headerBackgroundColor || "#F2B705";
	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: 0.5,
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100vh",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 9999,
					}}
				>
					{headerText}
					{logoImage && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
						/>
					)}
					{subtitle && (
						<Box
							component="h1"
							sx={{
								fontSize: isSmallScreen ? 24 : 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: "10px",
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{subtitle}
						</Box>
					)}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
				{introContent && (
					<Box component="p" sx={estiloP}>
						{introContent}
					</Box>
				)}
				<Box
					sx={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						gap: 2,
						position: "relative",
						marginTop: "12px",
					}}
				>
					{sections.length > 0 && (
						<Box data-block-id="text-2" sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
							<Box>
								{sections[0].title && (
									<Box component="h3" sx={estiloH3}>
										{sections[0].title}
									</Box>
								)}
								{sections[0].body && (
									<Box component="p" sx={estiloP}>
										{sections[0].body}
									</Box>
								)}
							</Box>
							{sections[0].consejo?.text && (
								<Box
									sx={{
										backgroundColor: "#F2B705",
										border: "6px solid #ca9904",
										padding: 2,
										fontSize: 9,
										borderRadius: "50%",
										color: "#000!important",
										width: 130,
										height: 130,
										aspectRatio: 1,
										textAlign: "center",
										display: "flex",
										justifyContent: "center",
										flexDirection: "column",
										alignItems: "center",
										marginTop: "-20px",
									}}
								>
									{sections[0].consejo.text}
								</Box>
							)}
						</Box>
					)}

					{sections.length > 1 && (
						<Box
							data-block-id="text-3"
							sx={{
								display: "flex",
								gap: 2.5,
								alignItems: "flex-start",
								marginTop: isSmallScreen ? 0 : "-27px",
							}}
						>
							{sections[1].imageId && getImageSrc(sections[1].imageId) && (
								<Box
									component="img"
									src={getImageSrc(sections[1].imageId)}
									alt=""
									sx={{
										width: "40%",
										minWidth: 140,
										minHeight: 100,
										borderRadius: "12px",
										objectFit: "cover",
									}}
								/>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								{sections[1].sabiasQue?.[0] && (
									<Box sx={{ position: "absolute", top: -35, right: "65%" }}>
										<SabiasQue
											icono={sections[1].sabiasQue[0].icono}
											texto={sections[1].sabiasQue[0].texto}
										/>
									</Box>
								)}
								{sections[1].title && (
									<Box component="h3" sx={{ ...estiloH3, marginTop: 1 }}>
										{sections[1].title}
									</Box>
								)}
								{sections[1].body && (
									<Box component="p" sx={estiloP}>
										{sections[1].body}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{sections.length > 2 && (
						<Box data-block-id="text-4">
							{sections[2].title && (
								<Box
									component="h3"
									sx={{ ...estiloH3, marginTop: isSmallScreen ? 0 : 0 }}
								>
									{sections[2].title}
								</Box>
							)}
							{sections[2].body && (
								<Box component="p" sx={estiloP}>
									{sections[2].body}
								</Box>
							)}
						</Box>
					)}

					{llegar?.title && llegar?.content && (
						<Box
							data-block-id="text-5"
							sx={{
								backgroundColor: "#fbf0cf",
								border: "3px solid #F2B705",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 12,
								color: "#333",
								width: isSmallScreen ? "60%" : "100%",
							}}
						>
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: "#ca9904",
									textTransform: "uppercase",
									paddingLeft: 0.5,
								}}
							>
								{llegar.title}
							</Box>
							<Box
								component="ul"
								sx={{ paddingLeft: "20px", margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: llegar.content }}
							/>
						</Box>
					)}

					{sticker2 && (
						<Box
							component="img"
							src={sticker2}
							alt=""
							sx={{
								width: 100,
								position: "absolute",
								bottom: 0,
								right: isSmallScreen ? -30 : 0,
							}}
						/>
					)}
					{tipBox?.text && (
						<Box
							data-block-id="text-6"
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 90 : 70,
								right: isSmallScreen ? 0 : 30,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: 11,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 160,
							}}
							dangerouslySetInnerHTML={{ __html: tipBox.text }}
						/>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template169.thumbnail = "/images/template-1.png";
export default Template169;
